export const scrollNextField = () => {
  // Manual form: scroll to the current active field, or the email consent field if email is filled
  const current = document.querySelector('.carlead-creation-field-container--is-current');
  const lastField = document.querySelector('.carlead-creation-form-button');
  const emailFilled = document.querySelector('.carlead-creation-field-container--email.carlead-creation-field-container--is-selected + .carlead-creation-field-container--EMAIL_EVALUATION_CONSENT');
  // Chat mode (for Conversational Lead): manual form fields won't exist, scroll to the chat UI instead
  const chatWrapper = document.querySelector('.conversational-lead__chat-wrapper');
  const scrollToElement = element => {
    const offset = 100;
    const elementTop = element.getBoundingClientRect().top + window.scrollY;
    const targetPosition = elementTop - offset;
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  };

  // Pick the best available target in order of priority; guard against all being null
  const target = emailFilled || current && (current.previousSibling || current) || chatWrapper || lastField;
  if (target) {
    scrollToElement(target);
  }
};